module.exports = __webpack_public_path__ + "img/124.d80a24f7.jpg";